import { FC, ReactElement } from "react";
import {
  CircularProgress,
  Grid,
  IconButton,
  Stack,
  SxProps,
  Typography,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

import Modal from "..";
import { tokens } from "@/tokens";
import { ContainerHeading, StyledContainedButton } from "./styles.tsx";

interface ModalProps {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  children: ReactNode[] | ReactNode;
  title: string;
  subTitle?: string;
  buttonText: string;
  buttonAction: () => void;
  isConfirmButtonLoading?: boolean;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  modalStyles?: React.CSSProperties | SxProps;
  buttonLoader?: boolean;
  hideActionButton?: boolean;
  hideCancelButton?: boolean;
}

const ModalV2: FC<ModalProps> = ({
  show,
  setShow,
  children,
  title,
  subTitle,
  buttonText,
  hideActionButton = false,
  buttonAction,
  isConfirmButtonLoading = false,
  modalStyles,
  maxWidth = "sm",
  hideCancelButton = false,
  buttonLoader = false,
}): ReactElement => {
  return (
    <Modal
      sx={modalStyles}
      open={show}
      onClose={() => setShow(false)}
      maxWidth={maxWidth}
      hideClose
    >
      <div>
        <ContainerHeading>
          <Stack justifyContent={"flex-end"} alignItems={"flex-end"}>
            <IconButton sx={{ padding: 0 }} onClick={() => setShow(false)}>
              <CloseIcon sx={{ position: "absolute", top: "-9px" }} />
            </IconButton>
          </Stack>

          <Typography variant="h3" fontWeight={tokens.fontWeight.bold} color={tokens.bg.surface}>
            {title}
          </Typography>
          {subTitle && (
            <Typography variant="h6" fontWeight={tokens.fontWeight.bold} color={tokens.text.muted}>
              {subTitle}
            </Typography>
          )}
        </ContainerHeading>
        {children}
        <Grid container spacing={2}>
          <Grid item xs={6}>
          {!hideCancelButton && (
            <StyledContainedButton
              disabled={isConfirmButtonLoading}
              size="large"
              title="Cancel"
              variant="outlined"
              onClick={() => setShow(false)}
            />
          )}
          </Grid>
          <Grid item xs={6}>
          {!hideActionButton && (
            <StyledContainedButton
              disabled={isConfirmButtonLoading || buttonLoader}
              size="large"
              title={buttonText}
              onClick={buttonAction}
              {...(isConfirmButtonLoading && {
                startIcon: (
                  <CircularProgress sx={{ color: "white" }} size={20} />
                ),
              })}
            />
          )}
            </Grid>
        </Grid>
      </div>
    </Modal>
  );
};

export default ModalV2;
